import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class Capitalize implements PipeTransform {
  transform(value: string): string {
    value = value.substr(0,1).toUpperCase() + value.substring(1).toLowerCase();
    return value;
  }
}